<template>
    <div class="card current-bonus-card p-3 d-flex flex-column gap rounded-more">
        <div class="d-flex flex-column flex-md-row justify-content-between gap">
            <div class="referral-code-section d-inline-flex align-items-center gap">
                <div class="d-inline-flex align-items-center gap">
                    <div>Referral code : {{ referralCode }}</div>
                    <button 
                        id="first-button" 
                        class="btn btn-sm btn__primary" 
                        style="right: 0" 
                        @click.stop.prevent="copyReferralCode" 
                        title="Copy Code">Copy</button>
                </div>

                <div class="text-success text-xs" v-if="copied">
                    Referral code copied successfully!
                </div>
            </div>

            <div class="level-section">
                <h3 class="text-md">Level : <b><span>{{ ibLevel }}</span></b></h3>
            </div>
        </div>

        <div class="bonus-section d-flex flex-column flex-lg-row align-items-center justify-content-between gap-2x p-3">
            <div class="d-flex flex-row align-items-center gap">
                <i class="fas fa-wallet fa-7x" style="color: #565555"></i>
                <div class="d-flex flex-column">
                    <h2>Current Bonus</h2>
                    <div class="text-xl">{{ currency }} {{ amount }}</div>
                </div>
            </div>

            <router-link to="/current-bonus" class="btn btn_outline_red">View Detail</router-link>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    name : "CurrentBonusCard",
    props : {
        level : {
            type : String,
            default : "-"
        },
        amount : {
            type : Number,
            default : 0
        },
        currency : {
            type : String,
            default : ''
        },
        referralCode : {
            type : String,
            default : ''
        }
    },
    data : () => ({
      copied : false,  
    }),
    computed : {
        ibLevel(){
            let levels = {
                'INTRODUCING_BROKER' : 'Agent',
                'PARTNER_IB' : 'Supervisor Area',
                'MASTER_IB' : 'Manager Area'
            }

            return levels[this.level] ?? '-'
        }
    },
    methods : {
        copyReferralCode(){
            let vm = this
            navigator.clipboard.writeText(vm.referralCode)
            vm.copied = true

            setTimeout(function(){
                vm.copied = false
            }, 5000)
        }
    }
}
</script>